import MessagePreview from "pages/ManagementPage/MessagePreview/MessagePreview";

export default MessagePreview;
